import {
    ActionIcon,
    Anchor,
    Box,
    Container,
    Group,
    Stack,
    Text,
    Title,
    Tooltip,
} from "@mantine/core";
import { useEffect, useRef, useState, type FC } from "react";
import TrogLogo from "src/assets/img/trog_logo.png";
import AppSettings from "src/AppSettings";
import useCurrentUser from "src/hooks/authentication/useCurrentUser";
import * as Sentry from "@sentry/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ToggleFeedbackButton: FC = () => {
    const [feedback, _setFeedback] = useState(() => Sentry.getFeedback());
    const buttonRef = useRef<HTMLAnchorElement>(null);
    useEffect(() => {
        if (buttonRef.current) {
            const unsubscribe = feedback?.attachTo(buttonRef.current, {});
            return () => {
                unsubscribe?.();
            };
        }
    }, [buttonRef]);

    return (
        <Tooltip label="Report a Bug" withArrow>
            <ActionIcon color="inherit" ref={buttonRef as any}>
                <FontAwesomeIcon icon={AppSettings.icons.reportABug} />
            </ActionIcon>
        </Tooltip>
    );
};

interface IHeaderProps {}

const Header: FC<IHeaderProps> = () => {
    const user = useCurrentUser();

    return (
        <Box>
            <Container size="xl">
                <Group gap="md" justify="space-between">
                    <Box py="md">
                        <a href="https://www.trog.com.au/" className="no-mobile">
                            <img src={TrogLogo} width={80} />
                        </a>
                    </Box>
                    <Stack py="md" gap="xs" justify="center" align="flex-end">
                        <Title fw="bold" c="primary" component="div" order={2}>
                            Trial Management
                        </Title>
                        <Box>
                            {user ? (
                                <Group gap="xs">
                                    <Text fw="bold">{user.fullName}</Text>
                                    {AppSettings.sentry.enableReportABug && (
                                        <>
                                            <Box>|</Box>
                                            <ToggleFeedbackButton />
                                        </>
                                    )}
                                    <Box>|</Box>
                                    <Anchor href="/auth/logout">
                                        Logout <FontAwesomeIcon icon={AppSettings.icons.logout} />
                                    </Anchor>
                                </Group>
                            ) : (
                                <Anchor
                                    href={
                                        "/auth/openiddict?ReturnUrl=" +
                                        encodeURIComponent(
                                            window.location.pathname + window.location.search,
                                        )
                                    }
                                    className=""
                                >
                                    Login <FontAwesomeIcon icon={AppSettings.icons.login} />
                                </Anchor>
                            )}
                        </Box>
                    </Stack>
                </Group>
            </Container>
        </Box>
    );
};

export default Header;
